import repositories from '.';

const resource = '/master/common';

export default {
  getAppSetting: () => repositories.get(`${resource}/setting`),
  getAppState: () => repositories.get(`${resource}/app-state`),
};
